import * as React from 'react';

import type { HiveWorkingDocument } from '@gitbook/hive-client';
import type { Change, SelectionRange, Value } from '@gitbook/slate';
import type { List } from '@gitbook/util-immutable';

/**
 * Subscribe to the value and selections of a HiveWorkingDocument.
 */
export function useHiveWorkingDocumentValue(
    page: HiveWorkingDocument
): [Value, List<SelectionRange>, (change: Change) => void] {
    const value = React.useSyncExternalStore(
        (callback) => page.listen('value', callback),
        () => page.value
    );

    const selections = React.useSyncExternalStore(
        (callback) => page.listen('selections', callback),
        () => page.selections
    );

    const onChange = React.useCallback(
        (change: Change) => {
            page.applyChange(change);
        },
        [page]
    );

    return [value, selections, onChange];
}
